import { Text } from 'native-base';

export const GenericStateText = ({ label }: { label: string }) => {
  return (
    <Text alignSelf={'center'} fontSize={'md'} color={'gray.400'} pt={4} pb={6}>
      {label}
    </Text>
  );
};
